const topics = [
  { label: '#国产科幻', count: '2.3万讨论' },
  { label: '#暑期档电影', count: '5.8万讨论' },
  { label: '#悬疑剧场', count: '3.1万讨论' },
  { label: '#豆瓣高分', count: '8.5万讨论' },
  { label: '#综艺笑点', count: '4.2万讨论' },
  { label: '#追剧打卡', count: '6.7万讨论' },
  { label: '#动漫推荐', count: '3.9万讨论' },
  { label: '#经典港片', count: '2.8万讨论' },
  { label: '#韩剧热播', count: '4.5万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-hashtag"></i>话题讨论
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">热门话题标签</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全网影视圈热议话题，加入讨论分享你的观影观点
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer border border-background-200/60"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}